import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { Field, change } from 'redux-form';

import { Query, Builder, Utils } from 'react-awesome-query-builder';
import { CSSTransitionGroup } from 'react-transition-group';
import stringify from 'json-stringify-safe';

import { TextField, SelectField } from 'redux-form-material-ui';
import MenuItem from 'material-ui/MenuItem';

import { deepDiver } from 'helpers/utilities';
import * as validator from 'helpers/Validator';
import * as formatter from 'helpers/Formatter';

import Header from 'components/shared/Header';
import MultiSelectExtended from 'components/shared/MultiSelectExtended';

import config from './config';
import { initialTree, fromQueryBuilderToTree } from './values';

const MODIFY_SECURITY_DEPOSIT = 3;

class AddRuleForm extends React.Component {
  state = {
    humanizedRules: this.props.workflows[this.props.index] || {},
    initialHumanizedRules: this.props.workflows[this.props.index],
    tree: this.props.workflows[this.props.index]
      ? fromQueryBuilderToTree(this.props.workflows[this.props.index].rules)
      : initialTree,
    selectedField: deepDiver(this.props.workflows[this.props.index], 'action_type') || {},
    selectedSecondaryAction:
      deepDiver(this.props.workflows[this.props.index], 'metadata.secondary_action') || {},
    editingRule: this.props.workflows[this.props.index] === undefined,
  };

  onChange = (tree) => {
    const { queryBuilderFormat, queryString } = Utils;
    const jsonQueryFormat = stringify(queryBuilderFormat(tree, config), undefined, 2);
    const humanizedTextFormat = stringify(queryString(tree, config, true), undefined, 2);

    this.props.change('add_rules_form', `${this.props.name}.humanized_rule`, humanizedTextFormat);
    this.props.change('add_rules_form', `${this.props.name}.rules`, jsonQueryFormat);
  };

  editRule = () => {
    this.setState({ humanizedRules: null, editingRule: true });
  };

  cancelEditRule = () => {
    this.setState({ humanizedRules: this.state.initialHumanizedRules, editingRule: false });
  };

  render() {
    const { index } = this.props;

    return (
      <div key={index}>
        <div className="row" style={{ marginTop: '10px' }}>
          <Header name="RULE DETAILS" />
          {this.renderApplicationWarning()}
          {this.renderRuleDetails()}

          <Header name="PROPERTIES" />
          {this.renderProperties()}

          <Header name="CONDITIONS" />
          <div className="row" style={{ padding: '15px 0' }}>
            <CSSTransitionGroup
              transitionName="fade_out_buttons"
              transitionEnterTimeout={200}
              transitionLeaveTimeout={200}
            >
              {this.renderRuleCreator()}
              {this.renderRuleDescription()}
            </CSSTransitionGroup>
          </div>

          <Header name="ACTIONS" />
          {this.renderApplicationActions()}
          {this.renderApplicationSecondaryActions()}
          {this.renderApplicationSecondaryOtherAction()}
        </div>
      </div>
    );
  }

  renderApplicationWarning = () => {
    const { formName, index } = this.props;
    const target = deepDiver(this.props, `form.${formName}.values.workflows.${index}.target`);
    if (target !== 'Application') return;

    return (
      <div className="row" style={{ padding: '20px 10px 0' }}>
        <p style={{ textAlign: 'justify' }}>
          <i className="em em-warning" />
          <b style={{ color: '#ff3434', fontFamily: 'Circular-Bold' }}>IMPORTANT</b>
          <i className="em em-warning" /> Application workflows will automatically run credit checks
          on all applicants once their application has been submitted. By creating this workflow,
          you will be charged the agreed upon rate per credit check per applicant.
        </p>
      </div>
    );
  };

  renderRuleDetails = () => (
    <Fragment>
      <div className="row" style={{ padding: '10px 0 5px' }}>
        <div className="col-xs-6">
          <Field
            name={`${this.props.name}.name`}
            type="text"
            component={TextField}
            validate={validator.required}
            floatingLabelText="Rule Name"
            style={{
              marginTop: '-15px',
              fontSize: '14px',
              width: '100%',
            }}
            fullWidth
          />
        </div>

        <div className="col-xs-6">
          <Field
            name={`${this.props.name}.target`}
            component={SelectField}
            style={{ marginTop: '-15px', fontSize: '14px' }}
            floatingLabelText="Object to Target"
            fullWidth
            validate={validator.required}
            iconStyle={{ marginLeft: '20px !important' }}
          >
            <MenuItem key={1} value="Application" primaryText="Applications" />
          </Field>
        </div>
      </div>

      <div className="row" style={{ padding: '5px 0 10px' }}>
        <div className="col-xs-12">
          <Field
            name={`${this.props.name}.description`}
            style={{ marginTop: '-15px', fontSize: '14px' }}
            type="text"
            component={TextField}
            floatingLabelText="Description"
            fullWidth
            multiLine
            rows={2}
          />
        </div>
      </div>
    </Fragment>
  );

  renderProperties = () => (
    <div className="row" style={{ padding: '10px 0 15px' }}>
      <div className="col-xs-12">
        <div className="row" style={{ padding: '5px 0 0' }}>
          <h5>Assign to</h5>
        </div>

        <Field
          name={`${this.props.name}.properties`}
          component={MultiSelectExtended}
          multiple
          hintText="Properties"
          data={this.props.formProps.properties}
          style={{ fontSize: '14px', marginTop: '5px' }}
          fullWidth
          validate={validator.required}
          withResetSelectAllButtons
        />
      </div>
    </div>
  );

  renderApplicationActions = () => (
    <div className="row" style={{ padding: '20px 0 0px' }}>
      <div className="col-xs-12">
        <Field
          name={`${this.props.name}.action_type`}
          component={SelectField}
          style={{ marginTop: '-15px', fontSize: '14px' }}
          floatingLabelText="Action"
          fullWidth
          validate={validator.required}
          iconStyle={{ marginLeft: '20px !important' }}
        >
          <MenuItem
            key={1}
            value={1}
            primaryText="Reject Application"
            onClick={() => this.setState({ selectedField: 1 })}
          />
          <MenuItem
            key={2}
            value={2}
            primaryText="Flag Application"
            onClick={() => this.setState({ selectedField: 2 })}
          />
          <MenuItem
            key={3}
            value={3}
            primaryText="Modify Security Deposit"
            onClick={() => this.setState({ selectedField: 3 })}
          />
        </Field>
      </div>
    </div>
  );

  renderApplicationSecondaryActions = () => {
    if (this.state.selectedField !== MODIFY_SECURITY_DEPOSIT) return;

    return (
      <div className="row" style={{ padding: '20px 0 0px' }}>
        <div className="col-xs-12">
          <Field
            name={`${this.props.name}.metadata.secondary_action`}
            component={SelectField}
            style={{ marginTop: '-35px', fontSize: '14px' }}
            floatingLabelText="Amount"
            fullWidth
            validate={validator.required}
            iconStyle={{ marginLeft: '20px !important' }}
          >
            <MenuItem
              key={1}
              value={'full_rent'}
              primaryText="One Months Rent"
              onClick={() => this.setState({ selectedSecondaryAction: 'full_rent' })}
            />
            <MenuItem
              key={2}
              value={'half_rent'}
              primaryText="Half Months Rent"
              onClick={() => this.setState({ selectedSecondaryAction: 'half_rent' })}
            />
            <MenuItem
              key={3}
              value={'custom'}
              primaryText="Custom Amount"
              onClick={() => this.setState({ selectedSecondaryAction: 'custom' })}
            />
          </Field>
        </div>
      </div>
    );
  };

  renderApplicationSecondaryOtherAction = () => {
    if (this.state.selectedSecondaryAction !== 'custom') return;

    return (
      <div className="row" style={{ padding: '20px 0 0px' }}>
        <div className="col-xs-12">
          <Field
            name={`${this.props.name}.metadata.amount_cents`}
            style={{ marginTop: '-35px', fontSize: '14px' }}
            type="text"
            component={TextField}
            floatingLabelText="Amount"
            fullWidth
            {...formatter.currencyMaskCents}
          />
        </div>
      </div>
    );
  };

  renderRuleCreator = () => {
    const { humanizedRules, editingRule } = this.state;

    if (humanizedRules === {} || !editingRule) return;

    return (
      <div className="row">
        <Query
          {...config}
          value={Utils.checkTree(Utils.loadTree(this.state.tree), config)}
          renderBuilder={this.renderBuilder}
          onChange={this.onChange}
        />
        {this.cancelUndoEditRule()}
      </div>
    );
  };

  cancelUndoEditRule = () => {
    const { initialHumanizedRules } = this.state;
    if (!initialHumanizedRules) return;

    return (
      <div className="row" style={{ textAlign: 'center' }}>
        <button type="button" className="link-button" onClick={this.cancelEditRule}>
          cancel edit
        </button>
      </div>
    );
  };

  renderRuleDescription = () => {
    const rules = this.state.humanizedRules;
    if (!rules || !rules.humanized_rule) return;

    return (
      <div className="row" style={{ textAlign: 'center' }}>
        <h5 style={{ textAlign: 'center', marginBottom: '5px' }}> {rules.humanized_rule} </h5>
        <button type="button" className="link-button" onClick={this.editRule}>
          click to edit
        </button>
      </div>
    );
  };

  renderBuilder = (props) => (
    <div className="query-builder">
      <Builder {...props} />
    </div>
  );
}

export default connect(
  (store) => ({
    form: store.form,
    workflows: store.insights.workflows,
  }),
  { change }
)(AddRuleForm);
